module.exports = __webpack_public_path__ + "img/content16.5beb2164.png";